<template>
  <div>
    <base-nav />
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import LocationService from '@/services/core/LocationService';

export default {
  async created() {
    window.addEventListener('scroll', this.onScroll);

    if (!LocationService.isCurrentLocation()) {
      const { address, location } = await LocationService.initialize();

      this.setAddress(address);
      this.setLocation(location);
    }
  },
  methods: {
    ...mapActions('profile', ['setLocation', 'setAddress']),

    onScroll() {
      if ((window.innerHeight + window.pageYOffset) >= document.body.scrollHeight) {
        this.$emit('scroll_ended');
      }
    },
  },
};
</script>

